import { j as a } from "../../jsx-runtime-CZlWR0BA.js";
import { memo as z, useMemo as g } from "react";
import { I as x } from "../../icon-DA-Zqp8s.js";
import { i as c } from "../../is-C_9S2gv0.js";
import { H as $, C as l } from "../../styled-components.browser.esm-CdvvWRMU.js";
const S = (e) => {
  switch (e.size) {
    case "xs":
      return e.theme.fontSizeNano;
    case "sm":
      return e.theme.fontSizeXxxs;
    case "md":
      return e.theme.fontSizeXs;
    case "lg":
      return e.theme.fontSizeSm;
  }
}, u = (e) => l`
  color: ${e.default};

  &:active {
    color: ${e.active};
  }

  &:focus {
    color: ${e.focus || e.active};
    outline: none;
  }

  &:hover {
    color: ${e.hover || e.active};
  }

  ${(t) => t.disabled && l`
      pointer-events: none;
      cursor: default;
      text-decoration: none;
      color: ${(r) => r.theme.colorNeutralDark};
    `}
`, j = $.a`
  color: ${(e) => e.theme.brandHighlightMedium};
  gap: ${(e) => e.theme.spacingInlineQuarckRem};
  font-family: ${(e) => e.theme.fontFamilySemibold};
  background-color: transparent;
  cursor: pointer;
  align-items: center;
  border: none;
  outline: none;
  padding: 0;
  ${({ block: e }) => e ? l`
        display: flex;
      ` : l`
      display: inline-flex;
      width: fit-content;
    `}

  ${({ theme: e, variant: t }) => {
  switch (t) {
    case "primary":
      return u({
        default: e.brandPrimaryMedium,
        active: e.brandPrimaryDark
      });
    case "highlight":
      return u({
        default: e.brandHighlightMedium,
        active: e.brandHighlightDark
      });
    case "neutral":
    default:
      return u({
        default: e.colorNeutralDarkest,
        active: e.colorNeutralDarkest
      });
  }
}}
`, k = $.span`
  font-size: ${(e) => e.theme.fontSizeNano};
  line-height: ${(e) => e.theme.lineHeightTight};
  font-size: ${S};
  align-items: center;
  display: flex;
  white-space: nowrap;
`, H = ({
  icon: e = null,
  hasIcon: t = !1,
  size: r = "sm",
  disabled: f = !1,
  variant: v = "primary",
  children: b,
  onClick: s,
  ...m
}) => {
  const d = "href" in m, i = c.string(e) || c.null(e), o = g(() => i ? "left" : e.position ?? "left", [i, e]), h = g(() => {
    if (!t)
      return null;
    const n = o === "left" ? "caret-left" : "caret-right", p = r;
    if (c.object(e)) {
      const y = {
        ...e,
        size: e.size ?? p,
        name: e.name ?? n
      };
      return /* @__PURE__ */ a.jsx(x, { ...y });
    }
    if (i)
      return /* @__PURE__ */ a.jsx(x, { name: e || n, size: p });
  }, [i, e, r, t, o]);
  return /* @__PURE__ */ a.jsxs(
    j,
    {
      as: d ? "a" : "button",
      type: d ? void 0 : "button",
      disabled: f,
      variant: v,
      onClick: (n) => {
        if (f) {
          n.preventDefault();
          return;
        }
        s == null || s(n);
      },
      ...m,
      children: [
        o === "left" && h,
        /* @__PURE__ */ a.jsx(k, { size: r, children: b }),
        o === "right" && h
      ]
    }
  );
}, P = z(H);
export {
  P as Link
};
